import { render, staticRenderFns } from "./crearMemoria.vue?vue&type=template&id=ef0fe948"
import script from "./crearMemoria.vue?vue&type=script&lang=js"
export * from "./crearMemoria.vue?vue&type=script&lang=js"
import style0 from "./crearMemoria.vue?vue&type=style&index=0&id=ef0fe948&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports